import styled, { css } from "styled-components";

import Props from "./props";

const Checkbox = styled.div<Props>`
    width: 1.125rem;
    height: 1.125rem;
    display: inline-block;
    /*border: 0.1rem solid ${props => props.theme.colors.black(0.54)};*/
    border-radius: 0.2rem;
    position: absolute;
    left: 1rem;
    transition: background-color 0.3s ease;
    overflow: hidden;
    ${({ active }) =>
        active &&
        css`
            background-color: ${props => props.theme.colors.primary(1)};
            border-color: ${props => props.theme.colors.primary(1)};
        `}
    &:after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border: 0.125rem solid ${props => props.theme.colors.primary(1)};
    }
    &:before {
        content: "";
        position: absolute;
        width: 1rem;
        height: 1rem;
        border: 0.125rem solid ${props => props.theme.colors.primaryInvert(1)};
        border-left: none;
        border-top: none;
        right: 0;
        bottom: 0;
        transform: rotateZ(45deg) translateY(-0.2rem) translateX(-0.4rem);
        opacity: 0;
        transition: opacity 0.3s ease;
        ${({ active }) =>
            active &&
            css`
                opacity: 1;
            `}
    }
    ${({ isSubLevel }) =>
        isSubLevel &&
        css`
            left: 3rem;
        `}
`;

export default Checkbox;
